import request from '@/utils/request'

//PC个人用户注册
export function registerPcUser(data) {
    return request({
        url: '/api/reg/pc/user',
        method: 'post',
        data:data
    })
}

//获取邮箱验证码
export function getEmailCode(data) {
    return request({
        url: '/api/client/user/email/send/code',
        method: 'post',
        data:data
    })
}

//校验邮箱验证码
export function requireEmailCode(data) {
    return request({
        url: '/api/client/user/email/check/code',
        method: 'post',
        data:data
    })
}

//合作商注册
export function registerPro(data) {
    return request({
        url: '/api/reg/pc/pro',
        method: 'post',
        data:data
    })
}

//员工注册
export function registerUser(data) {
    return request({
        url: '/api/reg/pc/staff',
        method: 'post',
        data:data
    })
}

//员工登录
export function loginForStaff(data) {
    return request({
        url: '/sys/authentication/loginForStaff',
        method: 'post',
        data:data
    })
}

//用户登录
export function loginForUser(data) {
    return request({
        url: '/sys/authentication/loginForUser',
        method: 'post',
        data:data
    })
}

//忘记密码
export function forgetPassword(data) {
    return request({
        url: '/api/login/forgot/pwd',
        method: 'post',
        data:data
    })
}
//用户协议
export function forgetPrivacyPolicy(data) {
    return request({
        url: '/api/client/app/query/privacy',
        method: 'post',
        data:data
    })
}